import { ShopItemType } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { ArrowsShop } from 'src/components/svg/Arrows';
import coin from 'src/assets/images/event/shop/shopCoin.webp';
import { FC } from 'react';

interface FreespinsPurchaseBlockProps {
  item?: ShopItemType;
}
export const FreespinsPurchaseBlock: FC<FreespinsPurchaseBlockProps> = ({ item }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center pt-[13px] pb-5">
      <p className="text-sp_title text-3xl font-bold pb-2.5 leading-[35px] text-center">
        {t('christmasShop.bonusSpins')}
      </p>
      <div className="flex flex-row justify-between w-full px-5 gap-2.5">
        <div className="flex flex-col items-start">
          <p className="text-base first-letter:uppercase text-sp_text font-bold leading-[22px] text-start">
            {t('christmasShop.foxCoins')}
          </p>
          <div className="flex flex-row items-center gap-[5px]">
            <img src={coin} alt="coin" className="w-7" />
            <p className="text-xl text-sp_text font-bold leading-[35px]">{item?.costPoints}</p>
          </div>
        </div>
        <ArrowsShop />
        <div className="flex flex-col items-end mb-5">
          <p className="text-base text-sp_text leading-[22px] pb-1 font-bold text-end">
            {t('christmasShop.freeSpins')}
          </p>
          <p className="bg-sp_freespins_number_bg text-xl  font-bold leading-5 text-center rounded-[20px] min-w-[42px] px-3 py-[11px] text-sp_freespins_number ">
            {item?.freeSpins?.number}
          </p>
        </div>
      </div>
    </div>
  );
};
